import { DevTool } from "@hookform/devtools";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Card, Modal, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../common/SnackUI";
import { paymentRequestDetailsAction } from "../../redux/toolkit/payments/payment-request-details";
import moment from "moment";

// schema
const catSchema = yup
  .object()
  .shape({
    amount: yup
      .number()
      .positive()
      .nullable()
      .required("Amount is required.")
      .typeError("Amount must be a positive value"),
  })
  .required();

export default function CreateCategory({ state, setState, paymentId }) {
  // state
  const {
    register,
    setValue,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm({ resolver: yupResolver(catSchema) });

  const dispatch = useDispatch();
  const createCat = useSelector((state) => state.paymetnDetail);
  const { status, message, data, loading } = createCat;
  const [snack, setSnack] = useState(false);
  // fn

  useEffect(() => {
    if (state) {
      dispatch(paymentRequestDetailsAction(paymentId));
    }
  }, [paymentId, state]);

  const handleClose = function () {
    setState(false);
  };

  return (
    <>
      {/* <Modal
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

        }}
        sx={{ overflow: "scroll" }}
        open={state}
        onClose={handleClose}
      >
        <Box className="modal_box" >
          <Card sx={{ width: 500, p: 5 }}>
            <Typography variant="h5" sx={{ mb: 5 }} align="center">
              Paymemt Details
            </Typography>
            <Stack spacing={3}>
              {Object.entries(data).map(([key, value]) => (
            
                <div key={key} style={{display:'flex',justifyContent:'space-between'}}>
                  {!["_id","publisher_id","approved_by"].includes(key)&&<><Typography variant="subtitle1">{ key.toUpperCase()}:</Typography>
                  <Typography>{  key === 'invoice' ? <img src={value} width="100" height="100"/>:key === 'status' ? value.slice(0,1)?.toUpperCase()+value.slice(1) : key === 'credit_at' ? moment(value).local().format('DD-MM-YYYY hh:mm:ss A') : key === 'approved_at' ? moment(value).local().format('DD-MM-YYYY hh:mm:ss A') :value} </Typography>
                  </>}
                </div>
              ))}

              <Stack direction="row" spacing={2}>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Close
                </Button>
              </Stack>
            </Stack>
          </Card>
        </Box>
      </Modal> */}

      <Modal
        open={state}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0,0,0,0.5)",
          overflow: "scroll",
          p: 2,
        }}
      >
        <Box className="modal_box">
          <Card sx={{ width: { xs: "90%", sm: 500 }, p: { xs: 3, sm: 5 } }}>
            <Typography variant="h5" sx={{ mb: 5 }} align="center">
              Payment Details
            </Typography>

            <Stack spacing={3}>
              {Object.entries(data).map(([key, value]) =>
                !["_id", "publisher_id", "approved_by"].includes(key) ? (
                  <Stack
                    key={key}
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="space-between"
                    alignItems={{ xs: "start", sm: "center" }}
                    spacing={1}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                      {key.toUpperCase()}:
                    </Typography>

                    <Typography
                      sx={{
                        wordBreak: "break-word",
                        textAlign: { xs: "start", sm: "end" },
                      }}
                    >
                      {key === "invoice" ? (
                        <img
                          src={value}
                          alt="invoice"
                          width="100"
                          height="100"
                        />
                      ) : key === "status" ? (
                        value.slice(0, 1).toUpperCase() + value.slice(1)
                      ) : key === "credit_at" || key === "approved_at" ? (
                        moment(value).local().format("DD-MM-YYYY hh:mm:ss A")
                      ) : (
                        value
                      )}
                    </Typography>
                  </Stack>
                ) : null
              )}

              <Stack direction="row" justifyContent="center" sx={{ mt: 3 }}>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Close
                </Button>
              </Stack>
            </Stack>
          </Card>
        </Box>
      </Modal>

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
      <DevTool control={control} />
    </>
  );
}

CreateCategory.propTypes = {
  state: PropTypes.any,
  setState: PropTypes.any,
};
